import { Checkbox } from 'antd'
import { CheckboxGroupProps as AntdCheckboxGroupProps } from 'antd/lib/checkbox'
import styled from 'styled-components'

import { themeColor } from '../theme'

export type CheckboxGroupProps = { error?: any; inline?: boolean } & AntdCheckboxGroupProps

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledGroup = styled(({ inline, ...rest }: CheckboxGroupProps) => <Checkbox.Group {...rest} />)`
  ${({ inline }) =>
    !inline &&
    `
    & {
      display: flex;
      flex-direction: column;

      & > * {
        margin-bottom: 20px;
      }

      & > *:last-child {
        margin-bottom: 0;
      }
    }
  `}

  .ant-checkbox-inner {
    border-radius: 4px;
    border: 1px solid ${themeColor('borderPrimary')};
  }

  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${themeColor('primary')};
      border-color: ${themeColor('primary')};
    }
  }
`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CheckboxGroup = ({ error, ...rest }: CheckboxGroupProps) => {
  return <StyledGroup {...rest} />
}
